/* eslint-disable import/prefer-default-export */
export function calculateVolume(flowRate, durationMinutes) {
  const flow = Number(flowRate) || 0;
  const time = Number(durationMinutes) || 0;

  return flow * time;
}
